export default __webpack_public_path__ + "static/media/kiatnakin.6af3235b.svg";